import { useEffect, useState } from "react";
import { imageLoaderTranslations, Language } from "../translations";

export type ImageLoaderProps = Pick<
  React.ImgHTMLAttributes<HTMLImageElement>,
  "src" | "alt" | "className" | "onClick" | "style"
> & { thumbnailSrc?: string; language?: Language };

const ImageLoader = ({
  src,
  thumbnailSrc,
  alt,
  className,
  onClick,
  language = "en",
}: ImageLoaderProps) => {
  const translations = imageLoaderTranslations[language];

  const [loaded, setLoaded] = useState(false);
  //   const [cancel, setCancel] = useState<null | (() => void)>(null);

  useEffect(() => {
    // if (cancel) cancel();

    // Create an image element
    const img = new Image();

    // Set a flag to track if the component is mounted
    let isMounted = true;

    // Load event listener
    const handleLoad = () => {
      if (isMounted) {
        setLoaded(true);
      }
    };

    setLoaded(false);
    const cleanup = () => {
      // Set the flag to false
      isMounted = false;
      // Abort the image loading by setting src to an empty string
      img.src = "";
    };
    // setCancel(cleanup);

    img.onload = handleLoad;

    // Set the src, which starts the loading
    if (src) img.src = src;
    if (alt) img.alt = alt;
    if (className) img.className = className;
    if (onClick) img.onclick = onClick as any;

    // The cleanup function
    return cleanup;
  }, [src]);

  if (thumbnailSrc) {
    return (
      <div style={{ position: "relative" }}>
        <img
          style={{ width: "100vw", maxHeight: "100vh" }}
          src={loaded ? src : thumbnailSrc}
          alt=""
        />
        {!loaded && (
          <div style={{ position: "absolute", top: 5, left: 5, color: "gray" }}>
            {translations.loadingFullQualityText}
          </div>
        )}
      </div>
    );
  } else if (loaded) {
    return <img src={src} alt="" />;
  } else {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          textAlign: "center",
          alignContent: "center",
        }}
      >
        {translations.loadingText}
      </div>
    );
  }
};

export default ImageLoader;
